module.exports = __webpack_public_path__ + "static/img/bcg_k8.efac0ffd.png";